import * as Sentry from "@sentry/nuxt";

export function useErrorReporter() {
	function reportError(e: unknown, context?: string) {
		Sentry.captureException(e);
		if (context) {
			console.error(context, e);
		} else {
			console.error(e);
		}
	}

	return {
		reportError,
	};
}
